// Re-export from the new folder structure.
// This file keeps App.js import path unchanged.
export { default } from './DocumentLibrary/index';
